const scheduledServicesDraggableCard = {
  serialNumber: "Número de Série: ",
  place: "Local: ",
  expirationDate: "Vencimento: ",
  service: "Serviço: ",
  company: "Empresa: "
};

export default scheduledServicesDraggableCard;
